'use client'

import {
   Badge,
   Box,
   Card,
   Container,
   SimpleGrid,
   Stack,
   Text,
   ThemeIcon
} from '@blocks'
import {
   siteSectionBodyHex,
   siteSectionCardRadiusPx,
   siteSectionHeadingHex,
   siteTypographySectionLeadFontSizeDesktop,
   siteTypographySectionLeadFontSizeMobile,
   siteTypographySectionTitlePrimaryFontSizeDesktop,
   siteTypographySectionTitlePrimaryFontSizeMobile
} from '@constants'
import {useMediaQuery} from '@hooks'
import {IconApps, IconMapPin, IconStar} from '@icons'

const reasons = [
   {
      icon: IconMapPin,
      title: 'Local & Convenient',
      description:
         'Based in Morrinsville, Clean Park is your local go-to for a proper clean — easy to access and built for the community.'
   },
   {
      icon: IconApps,
      title: 'All In One Place',
      description:
         'Automatic wash, self-serve bays, a dog wash, and vacuum stations — everything you need in a single location.'
   },
   {
      icon: IconStar,
      title: 'Quality Results',
      description:
         'From a quick refresh to a full clean, our facilities are designed to deliver a thorough result with minimal hassle.'
   }
]

export const WhyChoose = () => {
   const isMobile = useMediaQuery('(max-width: 768px)')

   return (
      <Box bg={'#f4f7ff'}>
         <Container
            py={isMobile ? 80 : 120}
            size={'xl'}
         >
            <Stack gap={isMobile ? 48 : 60}>
               <Stack
                  align={'center'}
                  gap={12}
               >
                  <Badge
                     variant={'light'}
                     color={'blue'}
                     size={'lg'}
                     fw={700}
                     tt={'uppercase'}
                  >
                     Why Choose Clean Park
                  </Badge>
                  <Text
                     c={siteSectionHeadingHex}
                     fz={
                        isMobile
                           ? siteTypographySectionTitlePrimaryFontSizeMobile
                           : siteTypographySectionTitlePrimaryFontSizeDesktop
                     }
                     fw={800}
                     lh={1.05}
                     ta={'center'}
                  >
                     Built for Convenience.
                  </Text>
                  <Text
                     c={siteSectionBodyHex}
                     fz={
                        isMobile
                           ? siteTypographySectionLeadFontSizeMobile
                           : siteTypographySectionLeadFontSizeDesktop
                     }
                     fw={500}
                     lh={1.7}
                     ta={'center'}
                     maw={620}
                  >
                     Clean Park is your local Morrinsville car wash,
                     built for convenience, quality, and ease of use.
                     With all our services in one place, we make it
                     simple to get the job done properly.
                  </Text>
               </Stack>
               <SimpleGrid
                  cols={{base: 1, md: 3}}
                  spacing={isMobile ? 20 : 28}
               >
                  {reasons.map((reason) => (
                     <Card
                        key={reason.title}
                        p={isMobile ? 32 : 40}
                        radius={siteSectionCardRadiusPx}
                        bg={'white'}
                        style={{
                           boxShadow:
                              '0 6px 28px rgba(10, 55, 121, 0.08)',
                           border: '1px solid #e2e8f4'
                        }}
                     >
                        <Stack gap={20}>
                           <ThemeIcon
                              p={12}
                              size={60}
                              color={siteSectionHeadingHex}
                              variant={'light'}
                              radius={'lg'}
                           >
                              <reason.icon
                                 stroke={1.6}
                                 size={32}
                              />
                           </ThemeIcon>
                           <Text
                              c={siteSectionHeadingHex}
                              fz={
                                 isMobile
                                    ? siteTypographySectionLeadFontSizeMobile
                                    : siteTypographySectionLeadFontSizeDesktop
                              }
                              fw={700}
                           >
                              {reason.title}
                           </Text>
                           <Text
                              c={siteSectionBodyHex}
                              fz={
                                 isMobile
                                    ? siteTypographySectionLeadFontSizeMobile
                                    : siteTypographySectionLeadFontSizeDesktop
                              }
                              fw={500}
                              lh={1.65}
                           >
                              {reason.description}
                           </Text>
                        </Stack>
                     </Card>
                  ))}
               </SimpleGrid>
            </Stack>
         </Container>
      </Box>
   )
}
